import { createStore } from 'effector';

const envs = {
  steamTractionTypeId: import.meta.env.APP_STEAM_TRACTION_TYPE_ID || '5',
  postalBaggageTrainSubCategoryId:
    import.meta.env.APP_POSTAL_BAGGAGE_TRAIN_SUB_CATEGORY_ID || '12',
  touristTrainSubCategoryId:
    import.meta.env.APP_TOURIST_TRAIN_SUB_CATEGORY_ID || '9',
  passengerTrainCategoryId:
    import.meta.env.APP_PASSENGER_TRAIN_CATEGORY_ID || '1',
  technicalTrainCategoryId:
    import.meta.env.APP_TECHNICAL_TRAIN_CATEGORY_ID || '3',
  trainNotBrandedId: import.meta.env.APP_TRAIN_NOT_BRANDED_ID || '1',
  acDcTractionTypeId: import.meta.env.APP_AC_DC_TRACTION_TYPE_ID || '4',
  railwayAdministrationRzdId:
    import.meta.env.APP_RAILWAY_ADMINISTRATION_RZD_ID || '1',
  passengerCarrierFpkId: import.meta.env.APP_PASSENGER_CARRIER_FPK_ID || '1',
  fpklDivisionId: import.meta.env.APP_FPKL_DIVISION_ID || '6',
  trainBrandId: import.meta.env.APP_TRAIN_BRAND_ID || '1',
  maxTrainSpeedId: import.meta.env.APP_MAX_TRAIN_SPEED_ID || '1',
  adminRoleId: import.meta.env.APP_ADMIN_ROLE_ID || '1',
  readOnlyWorkerRoleId: import.meta.env.APP_READ_ONLY_WORKER_ROLE_ID || '4',
} as const;

export type EnvIds = typeof envs;

export const $envIds = createStore<EnvIds>(envs);
